import React from "react"
import DemandSelector from "../actions/DemandSelector"
const DemandCardFooter = ({
  totalBooked,
  totalDemand,
  demandId,
  isExpanded = false,
  demandVerified = false,
}) => {
  return (
    <div
      className="text-[23px] flex justify-between items-baseline p-3"
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <DemandSelector demandId={demandId} isVerified={demandVerified} />
      <div className="flex gap-1 items-baseline">
        {isExpanded && <span className="text-sm text-gray-500">Booked :</span>}
        <p className="font-600 mb-0 text-gray-700">
          <span className="text-success">{totalBooked}</span> / {totalDemand}{" "}
          <small className="text-gray-600 font-400">Units.</small>
        </p>
      </div>
    </div>
  )
}

export default DemandCardFooter
